import React from 'react';
import useWishList from '../Wishlist/hooks/useWishlist';

const FavouriteCount = () => {
  const { flattenedFavourites } = useWishList((state) => state.favourites);

  return <>{flattenedFavourites.length}</>;
};

export default FavouriteCount;
